// import { date7DaysAfter, today } from "pages/echeck/utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as DiscountsActions } from "reducers/discounts";
// import * as i18n from "util/i18n";

const useEcheqFilters = () => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const { echeqFilters } = useSelector((state) => state.discounts);

    const tagOptions = {
        // createdFrom: { id: "createdRange", text: i18n.get("echecks.createdRange.label") },
        // payedFrom: { id: "payedRange", text: i18n.get("echecks.payedRange.label") },
        amountFrom: { id: "amountFrom", text: "Monto desde" },
        amountTo: { id: "amountTo", text: "Monto hasta" },
        payedFrom: { id: "payedRange", text: "Fecha de vencimiento" },
        emitted: { id: "emitted", text: "Emitido por" },
        receiver: { id: "receiver", text: "Recibido de" },
        // ownership: { id: "ownership", text: i18n.get("echecks.ownership.label") },
        // status: { id: "status", text: i18n.get("echecks.status.label") },
        // number: { id: "number", text: i18n.get("echecks.number.label") },
        // grouper: { id: "grouper", text: i18n.get("echecks.grouper.label") },
        // id: { id: "id", text: i18n.get("echecks.id.label") },
    };

    // const tagOptions = {
    //     "received.echeqs": {
    //         ...commonTagOptions,
    //         receiver: { id: "receiver", text: i18n.get("echecks.receiver.label") },
    //     },
    //     "emitted.echeqs": {
    //         ...commonTagOptions,
    //         emitted: { id: "emitted", text: i18n.get("echecks.emitted.label") },
    //     },
    // };

    const actionDispatch = (filter) => {
        dispatch(
            DiscountsActions.setEcheqFilters({
                ...filter,
                payedCheck: !!filter.payedFrom || !!filter.payedTo,
                pageNumber: 1,
            }),
        );
        dispatch(DiscountsActions.loadListEcheqRequest());
    };

    // useEffect(() => {
    //     if (Object.entries(echeqFilters).length === 0) {
    //         const initialValues = {
    //             emitted: "",
    //             ownership: "TODOS",
    //             number: "",
    //             orderColumName: "fecha_pago",
    //             orderDirection: "ascendent",
    //             payedCheck: false,
    //             emitedEcheq: true,
    //             status: "TODOS",
    //             option: "received.echeqs",
    //             // createdFrom: date7DaysBefore,
    //             // createdTo: today,
    //             createdFrom: null,
    //             createdTo: null,

    //             receiver: "",
    //             // payedFrom: today,
    //             // payedTo: date7DaysAfter,
    //             payedFrom: null,
    //             payedTo: null,
    //             amountFrom: null,
    //             amountTo: null,
    //         };
    //         dispatch(DiscountsActions.setEcheqFilters(initialValues));
    //     }
    // }, [echeqFilters]);

    useEffect(() => {
        if (echeqFilters) {
            const activeTags = Object.entries(echeqFilters)
                .filter(
                    (activeFilters) =>
                        !activeFilters.includes("") &&
                        !activeFilters.includes("TODOS") &&
                        !activeFilters.includes(null),
                )
                .map((filter) => filter[0])
                .filter((filterKey) => !!tagOptions[filterKey])
                .map((key) => tagOptions[key]);

            setTags(activeTags);
        }
    }, [echeqFilters]);

    const handleDelete = (i) => {
        const deletedFilter = tags.find((tag, index) => index === i).id;

        let tagFilters = {};
        switch (deletedFilter) {
            case "payedRange":
                tagFilters = {
                    payedFrom: null,
                    payedTo: null,
                };
                break;

            case "amountFrom":
                tagFilters = {
                    amountFrom: null,
                };
                break;

            case "amountTo":
                tagFilters = {
                    amountTo: null,
                };
                break;

            case "receiver":
                tagFilters = {
                    receiver: "",
                };
                break;

            default:
                tagFilters = {
                    [deletedFilter]: "",
                };
                break;
        }

        actionDispatch({
            ...echeqFilters,
            ...tagFilters,
        });
    };

    const handleCleanFilters = () => {
        const clearFilters = {
            ...echeqFilters,
            createdFrom: null,
            createdTo: null,
            ownership: "TODOS",
            status: "TODOS",
            number: "",
            grouper: "",
            id: "",
            emitted: "",

            amountFrom: null,
            amountTo: null,
            receiver: "",
            payedFrom: null,
            payedTo: null,
        };
        actionDispatch(clearFilters);
    };

    return { tags, handleDelete, handleCleanFilters, setFilters: actionDispatch };
};

export default useEcheqFilters;
